
import _ from 'lodash'
import client from "../../../services/session/apiClient";
const angular = require('angular')
angular.module('clientDashboardApp.admin.users.userManagerService', []).service('userManagerService', UserManagerService);

UserManagerService.$inject = ['$http', '$cacheFactory', 'cacheService', '$q', 'userService'];
function UserManagerService($http, $cacheFactory, cacheService, $q, userService) {
  this.http_ = $http;
  this.cache = $cacheFactory.get('apiCache');
  this.cs_ = cacheService;
  this.$q = $q;
  this.userService_ = userService;
}

UserManagerService.prototype.listUsers = function (accountId, query, offset, limit, skipLocationTotals = false, userIds) {
  var params = {
    accountId: accountId,
    offset: offset || 0,
    limit: limit || 100
  };
  if (query) {
    params.userQuery = query;
  }
  if (skipLocationTotals) {
    params.skipLocationTotals = 1
  }

  let url = '/v5/users';
  let cacheKey = this.cs_.generateCacheKey(accountId, JSON.stringify(params));

  if(userIds) {
    // create batches of 100
    let batches = _.chunk(userIds, 100)

    // fire them at once
    return this.$q.all(batches.map((xs) => {
      let theParams = {
        accountId: accountId,
        offset: offset || 0,
        limit: limit || 100,
        userId: xs
      }

      return this.http_.get(url, {params: theParams})
        .success(result => {this.$q.defer().resolve(result)})
        .error(() => this.$q.defer().reject())
    }))
    .then(userResponses => {
      // flatten them back down to just users
      return _.flatten(userResponses)
    })
  } else {
    return this.cs_.cachedGetRequest(url, {params: params}, 'user', cacheKey);
  }

};

UserManagerService.prototype.listAlertUsers = function (query, offset, limit, userIds) {
  let url = "/v5/users/alertUsers"
  let params = {
    offset: offset || 0,
    limit: limit || 100
  }

  if (query) {
    params.userQuery = query;
  }

  let cacheKey = this.cs_.generateCacheKey(JSON.stringify(params));
  if(userIds) {
    // create batches of 100
    let batches = _.chunk(userIds, 100)

    // fire them at once
    return this.$q.all(batches.map((xs) => {
      let theParams = {
        offset: offset || 0,
        limit: limit || 100,
        userId: xs
      }

      return this.http_.get(url, {params: theParams})
        .success(result => {this.$q.defer().resolve(result)})
        .error(() => this.$q.defer().reject())
    }))
      .then(userResponses => {
        // flatten them back down to just users
        return _.flatten(userResponses)
      })
  } else {
    return this.cs_.cachedGetRequest(url, {params: params}, 'user', cacheKey)
  }
}

UserManagerService.prototype.getUser = function (userId) {
  return this.http_.get('/v5/user/' + userId);
};

UserManagerService.prototype.getUserPreferences = function (userId) {
  return this.http_.get(`/v5/user/preferences`, {params: {userId}});
};

UserManagerService.prototype.upsertUserPreferences = function ({userId, userPreferences}) {
  return this.http_.post(`/v5/user/preferences/${userId}`, userPreferences )
};

let storedUsers = {}
let userPromises = {}
UserManagerService.prototype.getUsers = function (userIds) {
  let newUserIds = userIds.filter(id => typeof id !== "undefined" && typeof storedUsers[id] === "undefined");
  if (newUserIds.length === 0) {
    return this.$q.when(_.pick(storedUsers, userIds));
  }

  newUserIds = userIds.filter(id => typeof id !== "undefined" && typeof userPromises[id] === "undefined")
  if (newUserIds.length === 0) {
    return this.$q.all(_.pick(userPromises, userIds)).then(userSets => {
      let combined = {};
      _.forOwn(userSets, set => combined = {...combined, ...set})
      return _.pick(combined, userIds)
    })
  }

  let userPromise =  this.http_.get('/v5/users', {params: {userId: userIds}}).then(response => {
    let indexedUsers = {};
    response.data.users.forEach(user => {
      storedUsers[user.id] = indexedUsers[user.id] = user
      delete userPromises[user.id]
    });

    return angular.copy(indexedUsers);
  })
  userIds.forEach(id => {
    userPromises[id] = userPromise
  })

  return userPromise
}

UserManagerService.prototype.addUser = function (user) {
  return this.http_.post('/v5/users', user);
};

UserManagerService.prototype.updateUser = function (user) {
  return this.http_.put('/v5/users/' + user.id, user).then(response => {
    storedUsers = {}
    return response
  });
};

UserManagerService.prototype.updateUserPassword = function (user) {
  return this.http_.put('/v5/users/' + user.id + '/password', user);
};

UserManagerService.prototype.deleteUser = function (user) {
  return this.http_.delete('/v5/users/' + user.id);
};

UserManagerService.prototype.userTypes = function (accountId) {
  return this.userService_.currentUser().then(user => {
    return this.http_.get('/v5/userTypes', {params: {
      accountId: accountId || user.accountId
    }});
  })
};

UserManagerService.prototype.listUserLocations = function (userId, query) {
  var params = {};
  if (query) {
    params.query = query;
  }
  var url = '/v5/users/' + userId + '/locations';
  var cacheKey = this.cs_.generateCacheKey(userId, query);
  return this.cs_.cachedGetRequest(url,{params:params},'userLocation',cacheKey);
};

UserManagerService.prototype.setUserStatus = function(userId, isEnabled) {
  return this.http_.post(`/v5/users/${userId}/status`, {enabled: isEnabled}).then(response => {
    this.cs_.refreshCache('user');
    return response.status == 200
  })
}

UserManagerService.prototype.addLocationsToUser = function (userId, locationIds) {
  return this.http_.post('/v5/users/' + userId + '/locations', {locationIds: locationIds});
};

UserManagerService.prototype.removeLocationsFromUser = function (userId, locationIds) {
  return this.http_.post('/v5/users/' + userId + '/locations/delete', {locationIds: locationIds});
};

UserManagerService.prototype.listUserGroups = function (userId, query) {
  var url = '/v5/users/' + userId + '/groups';
  var params = {}
  if(query){
    params.query = query
  }
  var cacheKey = this.cs_.generateCacheKey(userId, JSON.stringify(params));
  return this.cs_.cachedGetRequest(url,{params: params},'userGroup',cacheKey);
};

UserManagerService.prototype.addGroupsToUser = function (userId, groupIds) {
  return this.http_.post('/v5/users/' + userId + '/groups', {groupIds: groupIds});
};

UserManagerService.prototype.removeGroupsFromUser = function (userId, groupIds) {
  return this.http_.post('/v5/users/' + userId + '/groups/delete', {groupIds});
};

UserManagerService.prototype.exportUsers = function (accountId, userSearchQuery) {
  var params = {accountId: accountId};

  if(userSearchQuery){
    params.userQuery = userSearchQuery;
  }
  return this.http_.get('/v5/export/users', {params: params});
};

UserManagerService.prototype.exportUsersToLocations = function (accountId, userSearchQuery) {
  var params = {accountId: accountId};

  if(userSearchQuery){
    params.userQuery = userSearchQuery;
  }
  return this.http_.get('/v5/export/usersToLocations', {params: params});
};
